import { useMemo } from "react"
import { abbreviateName } from "../../../utils/abbreviateName"
import { cn } from "../../../utils/cn"

type AvatarSize = "sm" | "lg"

interface AvatarProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  name: string
  containerClassName?: string
  className?: string
  size?: AvatarSize
}

const sizeMap: Record<Exclude<AvatarSize, number>, string> = {
  sm: "size-6 text-xs",
  lg: "size-16 text-3xl",
}

function getSizeClasses(size: AvatarSize = "sm") {
  const fallback = sizeMap["sm"]
  const classes = sizeMap[size] || fallback
  const [wClass, hClass, textClass] = classes.split(" ")

  return { size: `${wClass} ${hClass}`, text: textClass }
}

export default function ProfileImage({
  name,
  containerClassName,
  className,
  size = "sm",
  ...props
}: AvatarProps) {
  const initials = useMemo(() => abbreviateName(name), [name])
  const { size: sizeClass, text: textSizeClass } = getSizeClasses(size)

  return (
    <span
      className={cn(
        "overflow-hidden rounded-full flex items-center justify-center bg-primary-dark-blue text-white flex-shrink-0",
        sizeClass,
        textSizeClass,
        containerClassName,
      )}
    >
      {props.src ? (
        <img
          className={cn("rounded-full object-cover", sizeClass, className)}
          {...props}
        />
      ) : (
        initials
      )}
    </span>
  )
}
